import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'

const i18nInstance = i18n.use(initReactI18next).use(Backend)

let isInitialized = false

export const initializeI18n = async () => {
  if (isInitialized) {
    return i18nInstance
  }

  const isLocalDev = window.location.hostname === 'localhost'
  const cdnUrl = document.documentElement.getAttribute('cdn-url') || ''

  await i18nInstance.init({
    lng: 'en-US',
    fallbackLng: 'en-US',
    debug: true,
    nsSeparator: false,
    keySeparator: false,
    ns: ['translation'],
    defaultNS: ['translation'],
    interpolation: {
      format: (value, format) => {
        if (format === 'lowercase') return value.toLowerCase()
        return value
      }
    },
    backend: {
      loadPath: isLocalDev ? '/lang/polang-{{lng, lowercase}}.json' : `${cdnUrl}/lang/polang-{{lng, lowercase}}.json`,
      crossDomain: true,
      withCredentials: true
    },
    resources: {}
  })

  isInitialized = true
  return i18nInstance
}

export default i18nInstance
